import { createContext, createRef, RefObject } from "react";
import MediaSourcePlayer from "../utils/video/MediaSourcePlayer";

/**
 * VideoContext is used to share the video buffer
 * between components. When a user navigates to a
 * new route, the video is preloaded and stored
 * in the context. This allows the video to be
 * played without any black screens.
 */
export const VideoContext = createContext<VideoContextType>({
	videoManagerRef: createRef(),
});

type VideoContextType = {
	videoManagerRef: RefObject<MediaSourcePlayer | null>;
};
